module.exports = __webpack_public_path__ + "img/lavallee.21f2190f.jpg";